/**
 * Created by Carsten Bühler
 * User: CBuehler on 08.12.2015
 * Copyright: xdot GmbH 2015
 */

import keyMirror from 'external/keymirror';

export const ActionTypes = {};

export const ClassNames = keyMirror({
    ChangeRecord: null
});





// WEBPACK FOOTER //
// ./js/constants/Constants.js